import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Users } from 'lucide-react';
import { useAuthStore } from '../../store/authStore';
import { createOrganizationProfile } from '../../lib/supabase/organization';
import { SignupForm } from '../../components/auth/SignupForm';

export default function ContactManagerSignup() {
  const [error, setError] = useState<string | null>(null);
  const signup = useAuthStore((state) => state.signup);
  const { user } = useAuthStore();
  const navigate = useNavigate();

  const handleSignup = async (email: string, password: string, name: string) => {
    try {
      await signup(email, password, name);
      navigate('/contactmanager/home', { replace: true });
    } catch (err) {
      setError(err instanceof Error ? err.message : 'An error occurred during signup. Please try again.');
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-white flex items-center justify-center px-4">
      <div className="max-w-md w-full">
        <div className="text-center mb-8">
          <div className="flex items-center justify-center space-x-2 mb-6">
            <Users className="w-10 h-10 text-blue-500" />
            <span className="text-3xl font-bold gradient-text">Contact Manager</span>
          </div>
          <h2 className="text-2xl font-bold text-gray-900">Create your account</h2>
          <p className="text-gray-600 mt-2">Get started with Contact Manager</p>
        </div>

        <SignupForm onSubmit={handleSignup} error={error} />
        
        <div className="mt-4 text-center">
          <p className="text-sm text-gray-600">
            Already have an account?{' '}
            <Link to="/contactmanager/login" className="text-blue-500 hover:text-blue-600">
              Sign in
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}